import { createAction } from 'typesafe-actions';
import { AnnotationSaveEvent } from '../models/annotation-save-event.model';
import { AnnotationResource } from '../resources/annotation.resource';
import { AnnotationRelationResource } from '../resources/annotation-relation.resource';

export const fetchVersionHistory = createAction(
  'FETCH_VERSION_HISTORY',
  resolvePayload => (annotatedDocumentId: number) =>
    resolvePayload({ annotatedDocumentId }),
);

export const fetchVersionHistorySuccess = createAction(
  'FETCH_VERSION_HISTORY_SUCCESS',
  resolvePayload => (saveEvents: AnnotationSaveEvent[]) =>
    resolvePayload({ saveEvents }),
);

export const fetchVersionHistoryError = createAction(
  'FETCH_VERSION_HISTORY_ERROR',
  resolvePayload => (error: string) => resolvePayload({ error }),
);

export const selectVersion = createAction(
  'SELECT_VERSION',
  resolvePayload => (saveEventId: number | null) =>
    resolvePayload({ saveEventId }),
);

export const setCompareAnnotations = createAction(
  'SET_COMPARE_ANNOTATIONS',
  resolvePayload => (
    saveEvent: AnnotationSaveEvent,
    annotations: AnnotationResource[],
    relations: AnnotationRelationResource[],
  ) => resolvePayload({ saveEvent, annotations, relations }),
);

export const clearCompareAnnotations = createAction(
  'CLEAR_COMPARE_ANNOTATIONS',
);

export const toggleDiffMode = createAction(
  'TOGGLE_DIFF_MODE',
  resolvePayload => (enabled: boolean) => resolvePayload({ enabled }),
);

export const toggleDiffFilter = createAction('TOGGLE_DIFF_FILTER');

export type Granularity = 'all' | 'hourly' | 'daily';

export const setGranularity = createAction(
  'SET_GRANULARITY',
  resolvePayload => (granularity: Granularity) =>
    resolvePayload({ granularity }),
);

export const clearVersionHistory = createAction('CLEAR_VERSION_HISTORY');
